import { m } from 'motion/react';
import { itemVariants } from '../../../utils/framer';
import {
  CarouselFieldsEnum,
  ImageTypeEnum,
} from '../../components/carousel/types/CarouselTypes';
import FaqBlock from '../../components/FaqBlock';
import { ContentTextBoxAndIcons } from '../../components/privatleasing/ContentTextBoxAndIcones';
import PrivatLeasingNavBar from '../../components/privatleasing/PrivatLeasingNavBar';
import { TextBox } from '../../components/privatleasing/TextBox';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';
import PriceCardGrid from '../cardgrid/cardgrid';
import Carousel from '../carousel/carousel';

import TextBlock from '../../components/100page/TextBlock';
import FlexibleTextBlock from '../../components/FlexibleTextBlock';
import InfoBoxImgTextLinks from '../../components/newKiaEV6/InfoBoxImgTextLinks';
import AnimatedSection from '../../components/privatleasing/AnimatedSection';
import PrivateLeasingHero from '../../components/privatleasing/PrivateLeasingHero';
import LinkButton from '../../components/ui/LinkButton';
import Newsletter, { ThemeEnum } from '../newsletter/newsletter';
import {
  companyLeasing,
  contentTextBoxAndIcons,
  electricCarLeasing,
  faqBlockPL,
  getStarted,
  gettingStarted,
  heroPrivatLeasing,
  kiaImageOne,
  kiaPrivatleasingskyddBlock,
  leasingAltenative,
  leasingGettingStarted,
  navLinksPL,
  popularLeasing,
  subHeadingOne,
  subHeadingTwo,
  textBox,
} from './privatleasing-copy';

const PrivatLeasing = () => {
  const hideControls = true;

  return (
    <main className="relative">
      <div id="top">
        <PrivateLeasingHero {...heroPrivatLeasing} />
      </div>
      <div className="w-full max-w-screen-kia mx-auto">
        <section className="flex flex-col justify-center items-center mx-auto mb-10 max-w-[110ch] text-center">
          <h1 className="text-center font-medium my-4 text-[32px] md:text-[40px] leading-[1.2] px-3">
            {textBox.title}
          </h1>
          <p className="font-light text-[18px] px-2">{textBox.body}</p>
        </section>

        <PrivatLeasingNavBar links={navLinksPL.links} />

        <section className="mb-10 lg:mb-20">
          <TwoFlexibleComponentBox
            noGap
            firstComponent={
              <ContentTextBoxAndIcons {...contentTextBoxAndIcons} />
            }
            secondComponent={<KIAImage {...kiaImageOne} />}
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
          />
        </section>

        <AnimatedSection id="leasing-offer" className="my-6">
          <m.h2
            className="text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3"
            variants={itemVariants}
          >
            {subHeadingOne.text}
          </m.h2>
          <m.div variants={itemVariants}>
            <PriceCardGrid
              hideControls={hideControls}
              modelCodes="JYW5EV2,9VW5,0TW5"
              trimCodes="JYW5D5G1GEV2GG0VD,9VW5ZHZ7ZKK728,0TW5K9A1TEV2KK914"
              imageType={ImageTypeEnum.EXTERIOR}
              fields="Privatbeskrivning,Privatleasingpris"
            />
          </m.div>
          <TextBox {...popularLeasing} />
        </AnimatedSection>

        <AnimatedSection id="popular-models" className="my-6">
          <m.h2
            className="text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3"
            variants={itemVariants}
          >
            {subHeadingTwo.text}
          </m.h2>
          <m.div variants={itemVariants}>
            <Carousel
              hideControls={hideControls}
              pricelist={false}
              fields="Privatleasingpris,Fordonskatt,Upptäck bilen,Kontakta återförsäljare,Byt trim,Privatbeskrivning,Sortera,Visa Filter"
              imageType={ImageTypeEnum.STUDIO}
              privateMileages="true"
              sort={CarouselFieldsEnum.PRIVATE_LEASING}
              sortBy="asc"
            />
          </m.div>
        </AnimatedSection>
        <AnimatedSection
          id="how-it-works"
          className="px-4 my-14 mx-auto w-full max-w-7xl"
        >
          <m.h2
            variants={itemVariants}
            className="text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-14"
          >
            {getStarted.title}
          </m.h2>
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...gettingStarted.image} />}
            secondComponent={
              <FlexibleTextBlock content={gettingStarted.content} />
            }
          />
        </AnimatedSection>
        <AnimatedSection
          id="leasing"
          className="px-4 my-14 mb-20 mx-auto w-full max-w-7xl"
        >
          <div className="max-w-5xl mx-auto mb-14 text-center">
            <m.h2
              className="text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px]"
              variants={itemVariants}
            >
              {electricCarLeasing.title}
            </m.h2>
            <m.p
              className="text-base md:text-[18px] font-light mb-6"
              variants={itemVariants}
            >
              {electricCarLeasing.text}
            </m.p>
            <m.div
              variants={itemVariants}
              className="flex flex-wrap justify-center gap-8 md:gap-5"
            >
              <LinkButton
                bgColor="white"
                textColor="black"
                className="border-2 border-black h-12"
                {...electricCarLeasing.links[0]}
              />
              <LinkButton className="h-12" {...electricCarLeasing.links[1]} />
            </m.div>
          </div>

          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl my-16"
            mobilFirstComponentOnTop={false}
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-0"
            firstComponent={
              <TextBlock
                title={leasingGettingStarted.title}
                headingLevel={2}
                text={leasingGettingStarted.text}
                titleClassName="text-[28px] lg:text-[36px] leading-[40px] font-semibold mb-2 lg:mb-6 "
                textClassName="text-[16px] md:text-[18px] leading-[24px] font-light"
              />
            }
            secondComponent={<KIAImage {...leasingGettingStarted.image} />}
          />
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 "
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl mt-16 mb-8"
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-0 mb-6 lg:mb-0"
            firstComponent={<KIAImage {...kiaPrivatleasingskyddBlock.image} />}
            secondComponent={
              <FlexibleTextBlock content={kiaPrivatleasingskyddBlock.content} />
            }
          />
          <InfoBoxImgTextLinks headingPosition="below" {...leasingAltenative} />
        </AnimatedSection>
        <section className="px-4 my-14 mx-auto w-full max-w-7xl">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName=" lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={
              <FlexibleTextBlock content={companyLeasing.content} />
            }
            secondComponent={<KIAImage {...companyLeasing.image} />}
          />
        </section>
        <article id="faq" className="bg-slate-50 mb-20">
          <FaqBlock {...faqBlockPL} />
        </article>
        <AnimatedSection id="newsletter-section" className="mb-[90px]">
          <m.div variants={itemVariants}>
            <Newsletter
              hideControls={hideControls}
              theme={ThemeEnum.GREY}
              heading="Nyhetsbrev"
              description="Få de senaste nyheterna kring lanseringar av nya bilar, kampanjer, event och andra spännande reportage genom att gå med i nyhetsbrevet."
              buttonLabel="Gå med i nyhetsbrev"
              checkboxLabel="Nyhetsbrev. Jag samtycker till att Kia Sverige AB behandlar mina personuppgifter och förser mig med information från Kia Sverige. Jag kan när som helst säga upp prenumerationen på ett visst e-postnyhetsbrev eller liknande kommunikation genom att följa anvisningarna i respektive kommunikation."
              emailPlaceholder="Ange din e-postadress"
              thankYouMessage="Tack för att du prenumererar på vårt nyhetsbrev!"
            />
          </m.div>
        </AnimatedSection>

        <Snippet page="privatleasing" />
      </div>
    </main>
  );
};

export default PrivatLeasing;
